import "../css/style.scss"

console.log('It still works.')

// https://stackoverflow.com/questions/3813294/how-to-get-element-by-innertext
// var xpath = "//a[text()='Zurück zum Wohnpark St. Chrischona']";
// const matchingWohnpark = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue.parentElement;
// matchingWohnpark.style.display = "none"
// xpath = "//a[text()='Zurück zum Pflegeheim St. Chrischona']";
// const matchingPflegeheim = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue.parentElement;
// matchingPflegeheim.style.display = "none"
//
// const prevURL = document.referrer
// console.log(prevURL)
//
// if (prevURL.startsWith("https://wohnpark-st-chrischona.ch/")) {
//     console.log("Vom Wohnpark")
//     matchingWohnpark.style.display = "unset"
// } else if (prevURL.startsWith("https://pflegeheim-chrischona.ch/")) {
//     console.log("Vom Pflegeheim")
//     matchingPflegeheim.style.display = "unset"
// } else if (prevURL.startsWith("https://dmh-chrischona.org/")) {
//     console.log("Vom Mutterhaus")
// } else {
//     console.log("andere Quelle")
// }

window.toggleMobileNav = function() {
    var x = document.getElementById("nav-main");
    if (x.classList.contains('navhidden')) {
        x.classList.remove('navhidden')
    } else {
        x.classList.add('navhidden')
    }
}
import JobFilter from "./modules/JobFilter"
const jobfilter = new JobFilter()

import Search from "./modules/Search"
const search = new Search()
